import * as Styled from './OrganizationsListNav.styled';
import { SafeLocalStorage } from '@utils/localStorage';
import OrganizationIcon from 'app/_components/Icons/OrganizationIcon';

import { DoubleLeftOutlined, DoubleRightOutlined, SettingOutlined } from '@ant-design/icons';
import { Menu } from 'antd';
import Link from 'next/link';
import { useSearchParams } from 'next/navigation';
import React from 'react';

const OrganizationListNav: React.FC = () => {
  const searchParams = useSearchParams();
  const [collapsed, setCollapsed] = React.useState<boolean>(() => SafeLocalStorage.getItem('navCollapsed') !== 'false');

  const toggleCollapsed = (): void => {
    setCollapsed(!collapsed);
  };

  const menuItems = [
    {
      key: 'collapse',
      onClick: toggleCollapsed,
      icon: collapsed
        ? (
          <DoubleRightOutlined title='Expand sidebar' />
        )
        : (
          <DoubleLeftOutlined title='Collapse sidebar' />
        ),
    },
    {
      key: 'details',
      label: (
        <Styled.BlockLink href={{ pathname: '/organizations', query: { type: 'details' } }}>
          Organization
        </Styled.BlockLink>
      ),
      icon: (
        <Link href={{ pathname: '/organizations', query: { type: 'details' } }}>
          <OrganizationIcon />
        </Link>
      ),
    },
    {
      key: 'admin-notifications',
      label: (
        <Styled.BlockLink href={{ pathname: '/admin/notifications' }}>
          Admin Panel
        </Styled.BlockLink>
      ),
      icon: (
        <Link href={{ pathname: '/admin/notifications' }}>
          <SettingOutlined />
        </Link>
      ),
    },
  ];

  const getSelectedKeys = (): string[] => {
    const selectedItem = searchParams?.get('type');

    const allKeys = menuItems.flatMap((menuItem) => [menuItem.key]);

    if (!selectedItem || selectedItem === '') {
      return allKeys.filter((x) => x === 'details');
    }

    return allKeys.filter((key: string) => selectedItem.includes(key));
  };

  return (
    <Styled.OrganizationNav>
      {collapsed && <Styled.GlobalPopupMenuStyled />}

      <Styled.OrganizationMenu>
        <Menu
          expandIcon={<div />}
          mode='inline'
          selectedKeys={getSelectedKeys()}
          inlineCollapsed={collapsed}
          items={menuItems}
          inlineIndent={8}
          subMenuOpenDelay={0.1}
        />
      </Styled.OrganizationMenu>
    </Styled.OrganizationNav>
  );
};

export default OrganizationListNav;
